module.exports = __webpack_public_path__ + "static/media/rh_i.6d097019.jpg";